import { createFileRoute } from "@tanstack/react-router";
import { Accordion, Alert, Button, Code, Container, Stack, Text, Title } from "@mantine/core";
import { useCurrentProfile } from "@/features/profile/queries";
import { profileSchema } from "@/features/profile/schema";
import { ProfileForm } from "@/features/profile/components/ProfileForm";
import { ProfileAvatarEditor } from "@/features/profile/components/ProfileAvatarEditor";
import { useCurrentPlan } from "@/features/subscriptions/queries";

function Page() {
  const { session } = Route.useRouteContext();
  const query = useCurrentProfile(session.user.id);
  const plan = useCurrentPlan(session.user.id);
  const result = query.data?.status === 200 ? profileSchema.safeParse(query.data.body) : null;
  const profile = result?.success ? result.data : null;
  return (
    <Container size="md" py="xl">
      <Stack>
        <Title order={1}>Profile</Title>
        {!profile && !query.isPending ? <Alert color="red" title="Profile unavailable">
          <Text>{query.error?.message ?? (query.data?.status !== 200 ? "Could not load your profile. Please try again." : "The profile response could not be read. Please retry.")}</Text>
          <Button variant="subtle" loading={query.isFetching} onClick={() => void query.refetch()}>Retry profile</Button>
        </Alert> : null}
        <ProfileAvatarEditor userId={session.user.id} email={session.user.email} profile={profile} pending={query.isPending} plan={plan.data} />
        {profile ? <>
          {query.error ? <Alert color="red" title="Profile refresh failed">{query.error.message}<Button variant="subtle" onClick={() => void query.refetch()}>Retry profile refresh</Button></Alert> : null}
        </> : null}
        <ProfileForm key={session.user.id} userId={session.user.id} email={session.user.email} profile={profile} pending={query.isPending} />
        <Accordion>
          <Accordion.Item value="response">
            <Accordion.Control>Raw profile response</Accordion.Control>
            <Accordion.Panel>
              <Stack gap="xs">
                <Text size="sm">/v1/users/me/profile</Text>
                {query.error ? <Text c="red">{query.error.message}</Text> : null}
                {query.data ? <>
                  <Text size="sm">HTTP {query.data.status}</Text>
                  <Code block mah={400} tabIndex={0} style={{ overflowY: "auto", whiteSpace: "pre-wrap", overflowWrap: "anywhere", wordBreak: "break-word", minWidth: 0, maxWidth: "100%" }}>{JSON.stringify(query.data.body, null, 2)}</Code>
                </> : null}
              </Stack>
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      </Stack>
    </Container>
  );
}

export const Route = createFileRoute("/_authenticated/_protected/profile")({ component: Page });
